import * as React from "react";
const SvgFiRrHandFingersCrossed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-fingers-crossed_svg__a)">
      <path
        fill="#062147"
        d="M20.943 8.714a3.02 3.02 0 0 0-2.439-.674 2.88 2.88 0 0 0-1.494.75A2.98 2.98 0 0 0 15 8a2.99 2.99 0 0 0-2.553 1.446l-.064-.133 2.421-5.096a3 3 0 0 0-.04-2.518 3.02 3.02 0 0 0-1.96-1.604C11.408-.267 9.888.5 9.29 1.855l-.259.532-.239-.492C8.182.507 6.667-.265 5.266.095a3.01 3.01 0 0 0-1.963 1.597 3 3 0 0 0-.038 2.542l2.396 5.081-1.464 3.01-.568.567a5.43 5.43 0 0 0-1.605 3.865 5.43 5.43 0 0 0 1.601 3.868l1.033 1.033a7.95 7.95 0 0 0 5.656 2.343h6.687c2.757 0 5-2.243 5-5v-8c0-.882-.386-1.715-1.058-2.287m-2.119 1.3c.302-.047.596.03.823.224.224.19.353.468.353.762v2a1.001 1.001 0 0 1-2 0v-1.893c0-.538.362-1.018.824-1.093M14 11a1.001 1.001 0 0 1 2 0v2a1.001 1.001 0 0 1-2 0zm-1.7-8.969c.297.078.532.27.662.537a.99.99 0 0 1 .024.815l-3.912 8.231a2.98 2.98 0 0 0-1.906-.827l3.935-8.09c.218-.493.747-.785 1.196-.666M5.084 3.405a1 1 0 0 1 .68-1.375c.457-.118.98.177 1.21.704l.941 1.944-1.133 2.33-1.699-3.602zM17 22h-6.687a5.96 5.96 0 0 1-4.242-1.757L5.038 19.21a3.44 3.44 0 0 1-1.015-2.452 3.45 3.45 0 0 1 1.018-2.45l1.248-1.245a1.003 1.003 0 0 1 1.707.71 1 1 0 0 1-.292.705l-1.41 1.407a.999.999 0 1 0 1.412 1.416l1.411-1.407c.358-.358.601-.795.741-1.267l1.423-2.995.733 1.515A2.996 2.996 0 0 0 15 16.001a2.98 2.98 0 0 0 2-.78c.532.48 1.23.78 2 .78.352 0 .686-.072 1-.184v3.184c0 1.654-1.346 3-3 3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-fingers-crossed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandFingersCrossed;
